import React from "react";
import PropTypes from "prop-types";
import { BootstrapDialog } from "./styles";
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../../../utility/types/constant";

interface NotificationModalProps {
  children: any;
  sx?: any;
  title?: string;
  open: boolean;
  handleClose?: () => void;
}

const NotificationModal = (props: NotificationModalProps) => {
  const { children, sx, title, open, handleClose } = props;

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        open={open}
        aria-labelledby="customized-dialog-title"
        sx={{
          ...sx,
          width: "80",
        }}
        fullWidth
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontSize: "1.5rem" }}
          id="customized-dialog-title"
        >
          {title}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,

            color: colors.white,
            backgroundColor: colors.cancel,
            "&:hover": {
              color: colors.white,
              backgroundColor: colors.cancel,
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ fontSize: "1.1rem" }}>
          {children}
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
};

NotificationModal.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  sx: PropTypes.any,
};

export default NotificationModal;
